import React from 'react'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'
import { useSurveyQueryCustomerAttributeGroups } from '~/hooks/useSurveyQuery'

import { pathKey } from '../utils'

export const useCustomerAttributeGroup = () => {
  const { customerAttributeGroupId } = usePathParams(pathKey)
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()

  return React.useMemo(
    () =>
      customerAttributeGroups.find(
        (customerAttributeGroup) =>
          customerAttributeGroup.id === customerAttributeGroupId,
      ),
    [customerAttributeGroupId, customerAttributeGroups],
  )
}
